import { AdvaniaSmallLogo } from './advania-small-logo';
import { MicrosoftLogo } from './microsoft-logo';

export const Icons = [MicrosoftLogo, AdvaniaSmallLogo];
